import './PersonalDataSummary.scss';

import React from 'react';
import UserIcon from 'assets/icons/icon-user.svg';
import EditIcon from 'assets/icons/icon-edit-3-bold.svg';
import { formatText } from 'core/i18n';
import { getDocumentTypeLabelKey } from './utils/getDocumentTypeLabelKey';

export const PersonalDataSummary = ({ documentType, docNumber, handleModifyID }) => {
    return (
        <div className="personal-data-summary">
            <img src={UserIcon} alt="user-icon" className="personal-data-summary__user-icon" />
            <div className="personal-data-summary__data">
                <p className="personal-data-summary__data__title">{formatText('personalDataSection-yourUser')}</p>
                <div className="personal-data-summary__data__id">
                    {getDocumentTypeLabelKey(documentType)}: {docNumber}
                    <button className="personal-data-summary__data__id__button" onClick={handleModifyID}>
                        <img src={EditIcon} alt="edit-icon" className="personal-data-summary__edit-icon" />
                        {formatText('button-modify')}
                    </button>
                </div>
                <p className="personal-data-summary__data__text">
                    {formatText('personalDataSection-retrieveYourProcess')}
                </p>
            </div>
        </div>
    );
};
